import { Button, message, Modal, Popconfirm } from 'antd'
import { useContext, useRef, useState } from 'react'
import { useAppDispatch } from '../../../app/hooks'
import {
  create,
  EOffDutyType,
  remove,
  update,
} from '../../../features/off-duty/offDutySlice'
import { OffDutiesContext } from '../../../pages/OffDuties/OffDutiesContext'
import VacationForm from '../VacationForm'
import VacationFormPresentational, {
  IVacationFormValues,
} from '../VacationForm/VacationForm'

interface IProps {
  visible: boolean
  handleClose: () => void
}

export default function VacationModal(props: IProps) {
  const [confirmLoading, setConfirmLoading] = useState(false)
  const formRef = useRef<VacationFormPresentational>(null)
  const dispatch = useAppDispatch()
  const offDutiesContext = useContext(OffDutiesContext)

  const handleRemove = () => {
    if (!offDutiesContext.offDutyToEdit) {
      return
    }

    dispatch(remove(offDutiesContext.offDutyToEdit.id))
    props.handleClose()
  }

  const handleOk = () => formRef.current?.submit()

  const handleFinish = async (values: IVacationFormValues) => {
    setConfirmLoading(true)
    const vacationData = {
      from: values.period[0],
      to: values.period[1],
      membershipId: values.membershipId,
      type: EOffDutyType.Vacation,
    }

    if (offDutiesContext.offDutyToEdit) {
      dispatch(
        update({ id: offDutiesContext.offDutyToEdit.id, ...vacationData })
      ).then((action) => {
        setConfirmLoading(false)
        //@ts-ignore
        if (!action.error) {
          props.handleClose()
          message.success('Der Urlaub wurde geändert')
        }
      })
    } else {
      dispatch(create(vacationData)).then((action) => {
        setConfirmLoading(false)
        //@ts-ignore
        if (!action.error) {
          props.handleClose()
          message.success('Der Urlaub wurde erstellt')
        }
      })
    }
  }

  return (
    <Modal
      title={
        offDutiesContext.offDutyToEdit
          ? 'Urlaub editieren'
          : 'Urlaub einreichen'
      }
      visible={props.visible}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      onCancel={props.handleClose}
      destroyOnClose
      footer={[
        offDutiesContext.offDutyToEdit?.canUpdate && (
          <Button
            key="submit"
            type="primary"
            onClick={handleOk}
            loading={confirmLoading}
          >
            Speichern
          </Button>
        ),
        !offDutiesContext.offDutyToEdit && (
          <Button
            key="submit"
            type="primary"
            onClick={handleOk}
            loading={confirmLoading}
          >
            Einreichen
          </Button>
        ),
        <Button key="back" onClick={props.handleClose}>
          Abbrechen
        </Button>,
        // show the delete button only if
        //  1) editing an OffDuty
        //  2) user has the right to delete
        offDutiesContext.offDutyToEdit?.canRemove && (
          <Popconfirm
            title="Soll dieser Urlaub wirklich gelöscht werden?"
            onConfirm={handleRemove}
            okText="Ja"
            cancelText="Nein"
            key="remove"
          >
            <Button type="dashed" danger>
              Löschen
            </Button>
          </Popconfirm>
        ),
      ]}
    >
      <VacationForm
        ref={formRef}
        handleFinish={handleFinish}
        visible={props.visible}
      />
    </Modal>
  )
}
